var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8614 0L0.175417 7.86501C0.0931779 7.94467 0.0365965 8.04707 0.0129182 8.15909C-0.0107601 8.27111 -0.000454638 8.38765 0.0425126 8.49377C0.0854799 8.5999 0.159157 8.69079 0.254099 8.75479C0.34904 8.81879 0.460921 8.85298 0.575418 8.853H2.54942V19.463H7.74942V12.502H13.9664V19.463H19.1664V8.85001H21.1404C21.2549 8.84999 21.3668 8.81578 21.4617 8.75179C21.5567 8.68779 21.6304 8.59691 21.6733 8.49078C21.7163 8.38465 21.7266 8.2681 21.7029 8.15608C21.6792 8.04406 21.6227 7.94166 21.5404 7.862L10.8614 0Z",
    fill: "#F07F3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1675ea4d5256faaea422d743a27372b0.svg";
export { ForwardRef as ReactComponent };